import { createEnum } from './enum-kit.js';
import { enumLabelMap, enumValues } from './utils.js';
export const vehicleInboundBusinessTypeEnum = createEnum({
    SELF_OPERATED: ['self_operated', '自营业务', 'blue'],
    FINANCED: ['financed', '垫资业务', 'purple'],
    JOINT_PURCHASE: ['joint_purchase', '联合采购', 'cyan'],
    CLIENT_ENTRUSTED: ['client_entrusted', '客户委托', 'gold'],
});
export const VEHICLE_INBOUND_BUSINESS_TYPES = enumValues(vehicleInboundBusinessTypeEnum);
export const VEHICLE_INBOUND_BUSINESS_TYPE_LABEL_MAP = enumLabelMap(vehicleInboundBusinessTypeEnum);
export const vehicleInboundTypeEnum = createEnum({
    PURCHASE: ['purchase', '采购入库', 'blue'],
    TRANSFER: ['transfer', '调拨入库', 'orange'],
});
export const VEHICLE_INBOUND_TYPES = enumValues(vehicleInboundTypeEnum);
export const VEHICLE_INBOUND_TYPE_LABEL_MAP = enumLabelMap(vehicleInboundTypeEnum);
export const vehicleInboundStatusEnum = createEnum({
    PENDING_CONFIRMATION: ['pending_confirmation', '待确认', 'orange'],
    CONFIRMED: ['confirmed', '已确认', 'green'],
    REJECTED: ['rejected', '已拒绝', 'red'],
});
export const VEHICLE_INBOUND_STATUSES = enumValues(vehicleInboundStatusEnum);
export const VEHICLE_INBOUND_STATUS_LABEL_MAP = enumLabelMap(vehicleInboundStatusEnum);
//# sourceMappingURL=vehicle-inbound.js.map